export default __webpack_public_path__ + "static/media/nobody-killed.00595704.mp3";